import {
  Button, Grid, TextInput, Checkbox,

} from '@mantine/core';
import buttonClasses from '@/assets/styles/mantine/button.module.css';
import TextInputClasses from '@/assets/styles/mantine/textInput.module.css';
import CheckboxInputClasses from '@/assets/styles/mantine/checkbox.module.css';

const mantineTheme = {
  fontFamily: '"FUP Galil", Arial',
  fontSizes: {
    xs: '0.5rem',
    sm: '0.75rem',
    md: '1rem',
    lg: '1.25rem',
    xl: '1.5rem',
  },
  black: '#333',
  white: '#fff',
  cursorType: 'pointer',
  primaryColor: 'brand',
  colors: {
    brand: [
      '#ecf3fd',
      '#d7e2f5',
      '#aac3ee',
      '#7aa2e9',
      '#5486e4',
      '#3e75e1',
      '#336ce2',
      '#275bc9',
      '#1f51b4',
      '#092A60', // main
    ],
    secondary: [
      '#a0d6a9',
      '#90cf9b',
      '#80c88d',
      '#70c17e',
      '#60ba70', // main
      '#56a765',
      '#4d955a',
      '#43824e',
      '#3a7043',
      '#305d38',
    ],
  },
  components: {
    Button: Button.extend({ classNames: buttonClasses }),
    Grid: Grid.extend({ defaultProps: { gutter: 'xl' } }),
    Checkbox: Checkbox.extend({ classNames: CheckboxInputClasses }),
    TextInput: TextInput.extend({
      classNames: TextInputClasses,
      defaultProps: {
        placeholder: '',
        autoComplete: 'off',
        inputWrapperOrder: ['label', 'input', 'description', 'error'],
      },
    }),
  },
};

const cssVariables = {
  colorBrand: 'var(--mantine-color-brand-9)',
  colorSecondary: 'var(--mantine-color-secondary-4)',
  bodyBackground: '#fafafa',
  colorDanger: 'var(--mantine-color-red-4)',
};

export {
  mantineTheme,
  cssVariables,
};
